import styles from "../Cadastro.module.css";
import { Controller, useFormContext } from "react-hook-form";
import { FormControl, InputLabel } from "@mui/material";
import { WhiteInput } from "../../../../components/Inputs/InputText";
import { Fases } from "../../../../components/Combobox/Fases";
import { HelperText } from "../../../../components/Errors/HelperText";

const Tensao = ({  setIsLoading, setOpenError, setErrorMessage, camposDesabilitados, camposDesabilitadosUc, onKeyDown }) => {
    const { control, formState: { errors }} = useFormContext();

    return (
        <div style={{ width: "100%", minHeight: "405px" }}>
            <div className={styles['input-container']}>
                <Controller 
                    name="TensaoAtendimento"
                    control={control}
                    render={({field}) => (
                        <FormControl variant="outlined" className={styles['campos-m']} >
                            <InputLabel htmlFor="consulta-tensao" shrink sx={{ color: "#b8b8b8" }}>Tensão de atendimento (V)</InputLabel>
                            <WhiteInput
                                fullWidth 
                                placeholder="Tensão de atendimento" 
                                type="text" 
                                id="consulta-tensao" 
                                name="TensaoAtendimento" 
                                {...field} 
                                readOnly={camposDesabilitados} 
                                onKeyDown={onKeyDown}
                                className={`${errors?.TensaoAtendimento ? styles.campoComValorErrado : ""}`}
                            />
                            { errors?.TensaoAtendimento ?  (
                                    <HelperText text={errors?.TensaoAtendimento?.message} />
                            ) : '' }
                        </FormControl>
                    )}
                />

                <Controller 
                    name="TipoConexao"
                    control={control}
                    render={({ field }) => ( 
                        <FormControl variant="outlined" className={styles['campos-m']} style={{ zIndex: 2 }} >
                            <InputLabel htmlFor="consulta-tipoConexao" shrink sx={{ color: "#b8b8b8" }}>Conexão</InputLabel> 
                            <Fases 
                                field={field} 
                                placeholder="Conexão" 
                                id="consulta-tipoConexao" 
                                name="Conexao" 
                                readOnly={camposDesabilitados} 
                                disabled={camposDesabilitados} 
                                onKeyDown={onKeyDown}
                                className={`${errors?.TipoConexao ? styles.campoComValorErrado : ""}`}
                            />
                            { errors?.TipoConexao ?  (
                                    <HelperText text={errors?.TipoConexao?.message} />
                            ) : '' }
                        </FormControl>
                    )} 
                />
            </div>

            <div className={styles['input-container']}>
                <Controller 
                    name="PotenciaInstalada"
                    control={control}
                    render={({field}) => (
                        <FormControl variant="outlined" className={styles['campos-m']} >
                            <InputLabel htmlFor="consulta-potenciaInstalada" shrink sx={{ color: "#b8b8b8" }}>Potência Instalada (kW)</InputLabel>
                            <WhiteInput
                                fullWidth 
                                placeholder="Potência Instalada" 
                                type="text" 
                                id="consulta-potenciaInstalada" 
                                name="PotenciaInstalada" 
                                {...field} 
                                readOnly={camposDesabilitados} 
                                onKeyDown={onKeyDown}
                                className={`${errors?.PotenciaInstalada ? styles.campoComValorErrado : ""}`}
                            />
                            { errors?.PotenciaInstalada ?  (
                                    <HelperText text={errors?.PotenciaInstalada?.message} />
                            ) : '' }
                        </FormControl>
                    )}
                />

                <Controller 
                    name="FatorPotencia"
                    control={control}
                    render={({ field }) => ( 
                        <FormControl variant="outlined" className={styles['campos-m']} >
                            <InputLabel htmlFor="consulta-fatorPotencia" shrink sx={{ color: "#b8b8b8" }}>Fator Potência %</InputLabel>
                            <WhiteInput
                                fullWidth 
                                placeholder="Fator Potência" 
                                type="text" 
                                id="consulta-fatorPotencia" 
                                name="FatorPotencia" 
                                {...field} 
                                readOnly={camposDesabilitados} 
                                onKeyDown={onKeyDown}
                                className={`${errors?.FatorPotencia ? styles.campoComValorErrado : ""}`}
                            />
                            { errors?.FatorPotencia ?  (
                                    <HelperText text={errors?.FatorPotencia?.message} />
                            ) : '' }
                        </FormControl>
                    )} 
                />
            </div>

            {/* <div className={styles['input-container']}>
                <Controller 
                    name="Longitude"
                    control={control}
                    render={({field}) => (
                        <FormControl variant="outlined" className={styles['campos-m']} >
                            <InputLabel htmlFor="consulta-longitude" shrink sx={{ color: "#b8b8b8" }}>Longitude</InputLabel>
                            <WhiteInput
                                fullWidth placeholder="Longitude" type="text" id="consulta-longitude" name="Longitude" {...field}
                            />
                            { errors?.Longitude ?  (
                                    <HelperText text={errors?.Longitude?.message} />
                            ) : '' }
                        </FormControl>
                    )}
                />

                <Controller 
                    name="Latitude"
                    control={control}
                    render={({ field }) => ( 
                        <FormControl variant="outlined" className={styles['campos-m']} >
                            <InputLabel htmlFor="consulta-latitude" shrink sx={{ color: "#b8b8b8" }}>Latitude</InputLabel>
                            <WhiteInput
                                fullWidth placeholder="Latitude" type="text" id="consulta-latitude" name="Latitude" {...field}
                            />
                            { errors?.Latitude ?  (
                                    <HelperText text={errors?.Latitude?.message} />
                            ) : '' }
                        </FormControl>
                    )} 
                />
            </div> */}
        </div>
    )
}

export { Tensao }